import { isSearchConfluencePartial } from '@atlassian/search-client/confluence';
import {
	type ActivityItemEdge,
	type ActivityNode,
	type QuickFind1PEntity,
} from '@atlassian/search-client/recent-activities/types';
import {
	type SearchPageEdge,
	type SearchPageNode,
} from '@atlassian/search-client/search-page/types';

import type { SearchResultsFetchedCallback } from '../../../common/ui/app-context';
import type { QuickFindResult } from '../../../common/ui/quick-find/types.tsx';

const transformSearchPageNode = (node: SearchPageNode) => ({
	subtype: 'confluenceEntity' in node ? node.confluenceEntity?.subtype : undefined,
	id: node.id,
	type: node.type,
	status: node.status,
	productKey: 'confluence',
});

export function transformQuickFindConfluenceRecentActivities(
	filteredRecentActivities: QuickFindResult<ActivityItemEdge>[],
): Parameters<SearchResultsFetchedCallback>[0] {
	return filteredRecentActivities
		.filter((activity) => activity.data.node.object.product === 'confluence')
		.map((confluenceActivity: QuickFindResult<ActivityItemEdge>) => {
			const activity: ActivityNode<QuickFind1PEntity> = confluenceActivity.data.node;
			return {
				subtype: activity.object.data?.subtype,
				id: activity.object.id,
				type: activity.object.type,
				status: activity.object.data?.pageStatus,
				productKey: 'confluence',
			};
		});
}

export function transformQuickFindConfluenceResults(
	fetchedResults: QuickFindResult<SearchPageNode>[],
): Parameters<SearchResultsFetchedCallback>[0] {
	return fetchedResults
		.filter((result) => isSearchConfluencePartial(result.data))
		.map((confluenceResult: QuickFindResult<SearchPageNode>) => confluenceResult.data)
		.map(transformSearchPageNode);
}

export function transformSearchPageConfluenceResults(
	fetchedResults: SearchPageEdge[],
): Parameters<SearchResultsFetchedCallback>[0] {
	return fetchedResults
		.filter((result) => isSearchConfluencePartial(result.node))
		.map((result) => result.node)
		.map(transformSearchPageNode);
}
